import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';

const root = document.getElementById('root');

if (!root) {
    // Absolute last-resort: if the DOM isn't ready, show a plain message
    document.body.innerHTML = '<div style="color:white;background:#0f172a;height:100vh;display:flex;align-items:center;justify-content:center;font-family:sans-serif;font-size:1.2rem;">Loading EMI Flipbook...</div>';
} else {
    createRoot(root).render(
        <StrictMode>
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </StrictMode>,
    );
}
